const mainPrefix = 'app'
const prefix = 'work-plat'

export const addRoutePrefix = (path) => {
  if (path.startsWith(`/${prefix}`)) {
    return path
  }
  let _path = path.split('/').filter(Boolean)
  _path.unshift(prefix)
  _path.unshift(mainPrefix)
  return '/' + _path.join('/')
}
